<template>
    <div>
      <TopoComponent></TopoComponent>
        <div class="container vertical-align login escolha mt-4 text-center" >
            <div class="row">
                <form class="form-signin">
                    <div>
                    <h2>Confirme seus dados cadastrais: </h2>
                    <span class="dados">Email: {{paciente.email}}</span><br/>
                    <span class="dados">Celular: {{paciente.celular}}</span><br/>
                    <span class="dados">Dt Nascimento: {{paciente.dataNascimento}}</span>
                    <span class="dados">Nome da Mãe: {{paciente.nomeMae}}</span>
                    <span class="dados">CNS: {{paciente.cns}}</span>
                    <br/>
                    <div class="clearfix"></div>
                    <div class="mt-4">
                        <button class="btn btn-lg btn-primary btn-block button success" type="button" @click="redirectSenha">Meus dados estão corretos</button>
                        <button class="btn btn-lg btn-outline-danger btn-block button success" type="button" @click="redirectAlteracaoCadastral">Meus dados estão incorretos</button>
                    </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import OctadeskComponent from '@/components/OctadeskComponent'
import TopoComponent from '@/components/TopoComponent'

export default {
  components: { OctadeskComponent, TopoComponent },
  props: ['carteiraConvenio', 'clinicaid'],
  name: 'passo1',
  created(){
    //limpar
    sessionStorage.removeItem("idclinica")
    sessionStorage.removeItem("nomeMae")
    sessionStorage.removeItem("cns")
    sessionStorage.removeItem("empresa")
    sessionStorage.removeItem("cpf")
    sessionStorage.removeItem("dependentes")
    sessionStorage.removeItem("origem")

    //valida https (caso o cliente não esteja em HTTP faz o redirect para HTTPS.)
    if(location.href.indexOf("localhost") < 0 && location.href.indexOf("https") < 0){
        location.href = location.href.replace("http","https");
    }

    this.carregarPaciente()
  },
  data(){
      return {
          paciente : {
             email: null,
             celular: null,
             dataNascimento: null,
             nomeMae: null,
             cns: null,
             precisaValidacao: false
          }
      }
  },
  methods : {
    carregarPaciente(){
        //obtendo dados de conta para ativar
        this.$conexaApi.post('/integration/ativacao/paciente/carteira/obter-dados', {
            idClinica:  this.clinicaid,
            carteiraConvenio: this.carteiraConvenio
        }).then((response) => {
           this.paciente = response.data.object
           sessionStorage.setItem("token", this.paciente.token)
           sessionStorage.setItem("cpf", this.paciente.cpf)
           sessionStorage.setItem("idclinica", this.clinicaid)

            //no final do fluxo ele loga na web direto
           if(this.$route.query.webdireto){
               sessionStorage.setItem("clinica-direcionada", this.clinicaid)
           }
           if(this.paciente == null){
               location.href="/sucesso"
           }
           //Sem e-mail ou celular vai para validacao cadastral
           if (this.paciente.precisaValidacao) {
                this.redirectAlteracaoCadastral()
            }
         }).catch((error) => {
             location.href="/sucesso"
        }).finally(() => {
            NProgress.done()
        })
    },
    redirectSenha(){
        location.href = '/cadastrar-senha'
    },
    redirectAlteracaoCadastral(){
        location.href = '/atualizar-dados'
    }
  }
}
</script>

<style scoped>
.imgFalha{
    max-width: 180px;
   text-align: center;
}
.divFalha{
  text-align: center;
}
.imgContato{
    max-width: 50px;
   text-align: center;
}
.imgWhatsapp{
    max-width: 25px;
   text-align: center;
}
.imgEmail{
    max-width: 25px;
   text-align: center;
}
.mensagemFalha{
   color: gray;
   text-align: center;
   font-size: 20px;
}
.form-signin .btn-outline-danger{
  border:1px solid rgb(240, 82, 103);
  color: rgb(240, 82, 103);
  border-width: 2px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  text-transform: none;
  font-size: 16px;
  transition: 0.25s;
  --hover: rgb(240, 82, 103);
  font-weight: 700;
}
.form-signin .btn-outline-danger:hover, .form-signin .btn-outline-danger:focus {
  box-shadow: inset -16em 0 0 0 var(--hover),inset 16em 0 0 0 var(--hover);
  color: #fff;
}

.form-signin .btn-outline-danger:hover{
  border-color: rgb(240, 82, 103);
}

.form-signin .btn-outline-danger.animate:focus{
  color: rgb(240, 82, 103);
}
.dados{
    color:darkgray;
    font-weight: bold;
    margin-top: 5px;
    line-height: 3.7;
}
</style>
